import { useDispatch } from 'react-redux';
import { AppDispatch } from '../store';
import {
  toggleCart,
  setFinalPrice,
  setSubtotalPrice,
  addItem,
  setProductsQuantity,
  toggleWarranty,
  removeItem,
  setTotalSavings,
  setSavingsQuantityPrice,
  loadLazy,
  isHeroVisible,
  setFreeShipping,
  incrementItem,
  setLoader,
  addMainProduct,
  decrementItem,
} from './slice';
import { calculateMainTotals } from '@utils/cartHelpers';
import { ProductCartItem } from './types';
import { ProductItem, ProductVariantItem } from '../productsState/productsTypes';

export const useAppDispatch = () => useDispatch<AppDispatch>();

export const useCartActions = () => {
  const dispatch = useAppDispatch();

  const heroVisibleAction = () => dispatch(isHeroVisible());

  const toggleLoaderAction = () => dispatch(setLoader());

  const toggleCartAction = () => dispatch(toggleCart());
  const loadLazyComponentsAction = () => dispatch(loadLazy());

  const setFinalPriceAction = (payload: { total: number; savings: number }) => {
    dispatch(setFinalPrice(payload));
  };
  const setProductsQuantityAction = () => {
    dispatch(setProductsQuantity());
  };

  const toggleProtectionAction = (state: boolean) => {
    dispatch(toggleWarranty(state));
  };

  const setFreeShippingAction = (state: boolean) => {
    dispatch(setFreeShipping(state));
  };

  const setTotalSavingsAction = () => {
    dispatch(setTotalSavings());
  };

  const addItemAction = (item: ProductCartItem) => {
    dispatch(addItem(item));
  };

  const addMainProductAction = (item: ProductCartItem) => {
    dispatch(addMainProduct(item));
  };

  const incrementItemAction = (payload: {
    id: string;
    variant: productVariantItem;
    price: number;
    oldPrice: number;
  }) => {
    dispatch(incrementItem(payload));
  };

  const decrementItemAction = (payload: {
    id: string;
    variant: ProductVariantItem;
    price: number;
    oldPrice: number;
  }) => {
    dispatch(decrementItem(payload));
  };

  const removeItemAction = (id: string, variant: ProductVariantItem | null) => {
    dispatch(removeItem({ id, variant }));
  };

  const setSavingsQuantityPriceAction = () => {
    dispatch(setSavingsQuantityPrice());
  };

  const calculateTotalsAction = () =>
    dispatch((dispatch, getState) => {
      const state = getState();
      const { cartProducts, warrantyProduct } = state.cart;
      const { freeShippingPrice } = state.cart;

      const { mainTotal, mainSavings } = calculateMainTotals(cartProducts);

      function isProduct(item: CartItem): item is ProductItem {
        return (item as ProductItem).shipping_price !== undefined;
      }
      const productsWithShipping = cartProducts.filter(isProduct);
      const shippingCost = productsWithShipping.reduce((acc, product) => acc + Number(product.shipping_price), 0);
      const warrantyState = warrantyProduct.warrantyState;
      const wanrratyPrice = warrantyState ? warrantyProduct.price : 0;
      let subTotal;
      let finalSavings;
      if (mainTotal < freeShippingPrice) {
        subTotal = mainTotal + shippingCost + Number(wanrratyPrice);
        finalSavings = mainSavings;
      } else {
        subTotal = mainTotal + Number(wanrratyPrice);
        finalSavings = mainSavings;
      }
      dispatch(setSubtotalPrice({ subTotal }));
      dispatch(
        setFinalPrice({
          total: parseFloat(subTotal.toFixed(2)),
          savings: parseFloat(finalSavings.toFixed(2)),
        })
      );
    });

  return {
    heroVisibleAction,
    toggleLoaderAction,
    toggleCartAction,
    loadLazyComponentsAction,
    setFinalPriceAction,
    setProductsQuantityAction,
    toggleProtectionAction,
    setTotalSavingsAction,
    addItemAction,
    removeItemAction,
    incrementItemAction,
    decrementItemAction,
    setSavingsQuantityPriceAction,
    calculateTotalsAction,
    addMainProductAction,
    setFreeShippingAction,
  };
};
